import { render, staticRenderFns } from "./PopularTitles.vue?vue&type=template&id=d4839b50"
import script from "./PopularTitles.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopularTitles.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports